export default __webpack_public_path__ + "static/media/img_2.f1174ed3.jpg";